import script from "./MembershipForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MembershipForm.vue?vue&type=script&setup=true&lang=ts"

import "./MembershipForm.vue?vue&type=style&index=0&id=e142458a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e142458a"]])

export default __exports__